import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * A type-safe utility function that merges Tailwind CSS classes and handles class conflicts
 * @param inputs - Array of class values (strings, objects, arrays, undefined, null, false, 0)
 * @returns Merged and sanitized className string
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export type ClassNameValue = Parameters<typeof cn>[number]
